export default __webpack_public_path__ + "static/media/onboard_close.64aaed34.svg";